import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import usePaginationRouting from './hooks/usePaginationRouting';
const withPaginationRouting = (Component) => {
    const Hoc = ({ defaultPageSize, defaultPageNumber, hasPaginationRouting, ...props }) => {
        const paginationRouting = usePaginationRouting({
            defaultPageSize,
            defaultPageNumber,
        });
        return (<Component hasPaginationRouting={hasPaginationRouting} {...props} {...(hasPaginationRouting ? paginationRouting : {})}/>);
    };
    Hoc.displayName = `withPaginationRouting(${Component.displayName || Component.name}`;
    return hoistNonReactStatics(Hoc, Component);
};
export default withPaginationRouting;
